export enum DocumentMode {
    new = 1,
    edit = 2,
    read = 3
}
